import { StatusBar } from "@repo/core/components/layout/StatusBar";
import { View } from "@gluestack-ui/themed";
import { RootScaffoldProps } from "./types";
import { ScaffoldHeader } from "@repo/core/components/layout/Scaffolds/components/ScaffoldHeader";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { SafeAreaView } from "@repo/core/components/core/SafeAreaView";

export const RootScaffold = ({
  children,
  title = "Título",
  showHeader = true,
  bg = "$backgroundLight0",
  statusBarVariant = StatusBarVariantEnum.GREEN,
  minHeight = "auto",
  ...rest
}: RootScaffoldProps) => {
  return (
    <View flex={1} height={minHeight} w="$full" {...rest} bg={bg}>
      <StatusBar showCustomStatusBar statusBarVariant={statusBarVariant} />
      <SafeAreaView
        flex={1}
        h="$full"
        w="$full"
        height="$100vh"
        bg={bg}
        {...rest}
      >
        {showHeader && <ScaffoldHeader title={title} {...rest} bg={bg} />}
        {children}
      </SafeAreaView>
    </View>
  );
};
